/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetFrontCfgV2Rsp } from "./swagger/front";

export type IndexConfigItem = {
  key: string;
  type: string;
};

export type IndexConfig = {
  [category: string]: IndexConfigItem[];
};

export const CompStatus = {
  open: 1,
  close: 2,
} as const;
export type CompStatusTypes = keyof typeof CompStatus;

//登录限制
export const CompLoginStatus = {
  noLimit: 1, //不限制
  isLogin: 2, //已登录
  noLogin: 3, //未登录
} as const;
export type CompLoginStatusTypes = keyof typeof CompLoginStatus;

export const CompRechargeTypes = {
  noLimit: 1, //不限制
  isRecharge: 2, //已充值
  noRecharge: 3, //未充值
} as const;
export type CompRechargeTypesTypes = keyof typeof CompRechargeTypes;
//充值限制
export const CompRechargeStatus = {
  noLimit: 1, //不限制
  isRecharge: 2, //已充值
  noRecharge: 3, //未充值
} as const;
export type CompRechargeStatusTypes = keyof typeof CompRechargeStatus;

export type FrontCfgV2Map = {
  [key: string]: GetFrontCfgV2Rsp & Record<string, any>;
};

export type FrontCfgGameConfigData = {
  extGameFolder: string;
  gameFolder: string;
  gameIconRadius: number;
  iconStyle: string;
  orgGameFolder: string;
  pcLineCount: number;
  phoneLineCount: number;
  providerStyle: string;
};
export interface stringMap {
  [x: string]: string;
}
// 系统弹窗
export interface NoticeContent {
  click_id: number;
  click_params: string;
  deny_pack_type: number;
  desc: string;
  general: object;
  general_list: number[];
  label_list: number[];
  label_type_limit: number;
  login_type_limit: number;
  hide: string;
  id: number;
  img: string;
  index: number;
  name: string;
  pay_type: number;
  sort: number;
  title: stringMap;
  url?: stringMap;
  icon?: stringMap;
  tips: stringMap;
  button: stringMap;
  limit_login_type: number;
}

// 体育赛事
export const SportBetBySvgMap = {
  ["1"]: "Soccer",
  ["2"]: "Basketball",
  ["3"]: "Baseball",
  ["5"]: "Tennis",
  ["23"]: "Volleyball",
};

export const SportFirstSvgMap = {
  ["1"]: "Soccer",
  ["2"]: "Basketball",
  ["6"]: "Tennis",
  ["7"]: "Baseball",
  ["19"]: "Volleyball",
};

export type SportSvgMappKey = keyof typeof SportBetBySvgMap;
